import { render, staticRenderFns } from "./SimpleUserListTable.vue?vue&type=template&id=61fd2832"
import script from "./SimpleUserListTable.vue?vue&type=script&lang=js"
export * from "./SimpleUserListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports